import { render, staticRenderFns } from "./ActionPart.vue?vue&type=template&id=2ae36dd9&scoped=true"
import script from "./ActionPart.vue?vue&type=script&lang=js"
export * from "./ActionPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae36dd9",
  null
  
)

export default component.exports